import numeral from 'numeral'

/**
 * 
 * Download your wishlist copy
 * 
 */
export const presentationNavigationItem = (element) => {
    return /*html*/`
    <span class="presentation-navigation__item [ js-presentation-navigation-item ]" onclick="scrollToSlide('${element.dataset.title}')" data-title="${element.dataset.title}"><span>${element.dataset.title}</span></span>`
}


/**
 * 
 * Download your wishlist copy
 * 
 */
export const wishlistDownload = () => {
    return /*html*/`
    <h4 class="text-center">Download your Wishlist</h4>
    <p class="text-center">Download a copy of your Wishlist for future reference or to share with your designer.</p>`;
}


/**
 * 
 * Share your wishlist copy 
 * 
 */
export const wishlistShare = (link, logged_out = true) => {
    return /*html*/`
    <h4 class="text-center">Share your Wishlist</h4>
    <p class="text-center">Send your designer a link to view the product selections as they appear now on your Oliveri Wishlist.</p>
    <form class="[ js-share-wishlist-form ]">
        <div class="field text">
            <input class="[ js-from-name ]" type="text" placeholder="Your name" required>
        </div>
        <div class="field text">
        <input class="[ js-from-email ]" type="email" placeholder="Your email address" required>
        </div>
        <div class="field text">
            <input class="[ js-email ]" type="email" placeholder="Recipients email address" required>
        </div>
        <div class="field textarea">
            <textarea class="[ js-comments ]" placeholder="Comment"></textarea>
        </div>
        <div class="field textarea">
            <p class="small">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</p>
        </div>
        <button class="button arrow-link" id="send_wishlist">Send Wishlist<span class="buttonLoader"></span></button>
    </form>
    `;
}


/**
 * 
 * Return the template for an empty wishlist
 * 
 */
export const wishlistEmpty = () => {
    return '<h5></h5>';
}

/**
 * 
 * Return the template for a wishlist item
 * @param {object} item
 * 
 */
export const wishlistItem = (item) => {
    return /*html*/`
    <div class="wishlist__list__item" data-id="${item.id}">
        <div class="wishlist__list__item__image">
            <a href="${item.product.link}"  class="wishlist__list__item__image__link">
                <img src="${item.product.image || '/themes/mercury/dist/images/standard/placeholder.png'}" width="100" height="100" loading="lazy" alt="${item.product.title}">
            </a>
        </div>
        <div class="wishlist__list__item__details"> 
            <a href="${item.product.link}">
                <p>
                    ${(item.product.type) ? `<span class="colour--secondary">${item.product.type}<br></span>` : `<span class="colour--secondary">APPOLO<br></span>`}
                    <span class="colour--secondary">${item.product.title}<br></span>
                    <span class="colour--primary small">${item.product.code}<br></span>
                    </p>
                    </a>
                </p>
                ${(item.product.price) ? `<span class="colour--secondary" style="margin-right:1rem"><b>${item.product.price}</b></span>` : ``}
        </div>
        <p class="wishlist__list__item__wels">
            ${item.product.wels_rating}
        </p>
        <p class="wishlist__list__item__colour">
            ${item.product.colour}
        </p>
        <div class="wishlist__list__item__comments" style="display:none;">
            <p class="small">COMMENTS</p>
            <textarea onkeyup="event.target.parentNode.classList.add('changed')" value="${item.comments}"></textarea>
            <button class="[ js-save-comments ]" data-id="${item.sku}">Save</button>
        </div>
        <div class="wishlist__list__item__actions">
            ${(item.can_purchase) ? `<p><a href="${item.id}" class="[ js-move-to-cart ] button arrow-link">Move to cart <span class="buttonLoader"></span></a></p>` : `<p><a href="/about-us/find-us/stockists/" class="[ js-view-item ] button">Find a retailer</a></p>`}
            <span class="heart [ js-toggle-item-from-wishlist ] hearted" data-id="${item.product.code}">
                <img class="heart__image-1" src="themes/mercury/dist/images/svg/brown-heart.svg" width="25" height="21" loading="lazy" alt="brown-heart">
                <img class="heart__image-2" src="themes/mercury/dist/images/svg/brown-heart-full.svg" width="25" height="21" loading="lazy" alt="brown-heart">
                <svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg"><path d="M22.554 2.813c-2.025-1.81-5.196-1.75-7.144.18l-3.015 3.02-3.048-3.017C7.333 1 4.02 1 2.007 2.996a5.115 5.115 0 0 0 0 7.25L12.393 20.5l10.355-10.252a5.116 5.116 0 0 0 .183-7.061l-.183-.19-.193-.181v-.002Z" stroke="#818185" fill="none" fill-rule="evenodd"/></svg>
            </span>
        </div>
    </div>`
};


/**
 * 
 * Return the template for a sidecart item
 * @param {object} item
 * 
 */
export const sideCartItem = (item) => {
    return /*html*/`
    <div class="side-cart__tray__body__item" data-id="${item.product_id}">
        <a href="${item.url}" class="side-cart__tray__body__item__image">
            ${(item.thumbnail) ? `<img src="${item.thumbnail}" width="200" height="200" loading="lazy" alt="placeholder-image">` : `<img src="https://via.placeholder.com/200" width="200" height="200" loading="lazy" alt="placeholder-image">`}
        </a>
        <div class="side-cart__tray__body__item__details">
            <p><a href="${item.url}" class="colour--secondary"><span>${item.sku}</span><br>${item.title}</a></p>
            <p class="colour--primary smaller side-cart__tray__body__item__details__price">${numeral(parseFloat(item.unit_price).toFixed(2)).format('$0,0.00')} <span>${quantity(item)}</span></p>
        </div>
        <button class="side-cart__tray__body__item__remove [ js-remove-item-from-sidecart ]" data-remove-url="${item.item_actions.remove_all}" data-quantity="${item.quantity}" data-id="${item.product_id}">
            <img src="/themes/mercury/dist/images/svg/close-tiny.svg" width="14" height="14" loading="lazy" alt="close-tiny">
        </button>
    </div>`;
}

/**
 * 
 * Return the template for a sidecart item
 * @param {object} item
 * 
 */
export const sideCartEmpty = () => {
    return /*html*/`
    <div class="side-cart__tray__body__empty">
        <p class="text-center"><img src="/themes/mercury/dist/images/svg/placeholder.svg" width="200" height="200" loading="lazy" alt="empty-cart"></p>
        <p class="text-center">You have not selected any products.</p>
        <p class="text-center"><a href="/" class="button" onclick="event.preventDefault();document.body.classList.remove('sidecartActive');">Continue browsing<a></p>
    </div>`
}

/**
 * 
 * @returns {string} The template for the sidecartcart list header
 */
export const cartListHeader = () => {
    return /*html*/`
    <div class="cart__list__header">
        <div class="cart__list__header__product"><p>PRODUCT</p></div>
        <div class="cart__list__header__quantity"><p>QUANTITY</p></div>
        <div class="cart__list__header__total"><p>TOTAL</p></div>
        <div class="cart__list__header__remove"><p>&nbsp;</p></div>
    </div>`;
}


/**
 * 
 * @param {object} item 
 * @returns {string} The template for a cart list item
 */
export const cartListItem = (item) => {
    return /*html */`
    <div class="cart__list__item" data-id="${item.product_id}">
        <div class="cart__list__item__product">
            <div class="cart__list__item__product__image">
                <img src="${(item.thumbnail) ? item.thumbnail : `/themes/mercury/dist/images/standard/placeholder.png`}" width="100" height="100" loading="lazy" alt="${item.title}">
            </div>
            <div class="cart__list__item__product__details">
                <p class="no-margin">${item.type}</p>
                <h5 class="no-margin">${item.title}</h5>
                ${item.title ? `<p class="no-margin">${item.title}</p>` : ``}
            </div>
        </div>
        <div class="cart__list__item__quantity quantity">
            <div class="quantity__subtract [ js-subtract-quantity ]" data-id="${item.product_id}">
                <img src="/themes/mercury/dist/images/svg/subtract.svg" width="40" height="40" loading="lazy" alt="subtract">
            </div>
            <div class="quantity__input [ js-quantity ]" data-id="${item.product_id}">
                <input type="number" class="quantity__input__field" value="${item.quantity}" min="1" max="100">
            </div>
            <div class="quantity__add [ js-add-quantity ]" data-id="${item.product_id}">
                <img src="/themes/mercury/dist/images/svg/add.svg" width="40" height="40" loading="lazy" alt="add">
            </div>
        </div>
        <div class="cart__list__item__total">
            <p class="no-margin">${numeral(parseFloat(item.unit_price).toFixed(2)).format('$0,0.00')}</p>
        </div>
        <div class="cart__list__item__remove">
            <button class="[ js-remove-item-from-cart ]" data-remove-url="${item.item_actions.remove_all}" data-id="${item.product_id}">
                <img src="/themes/mercury/dist/images/svg/remove.svg" width="40" height="40" loading="lazy" alt="remove">
            </button>
        </div>
    </div>`;
}


/**
 * 
 * Resources item card template
 * 
 * @param {object} item 
 * @param {array} selected_items 
 * @returns {string} html
 */
export const resourcesItem = (item, selected_items) => {
    return /*html */`
    <div class="resources__actions__grid__item" data-id="${item.id}">
        <div class="resources__actions__grid__item__checkbox">
            <input id="${item.id}" type="checkbox" ${(selected_items && selected_items.includes(item.id)) ? `checked="checked"` : ``} value="${item.id}" class="resources__actions__grid__item__checkbox__input" onchange="toggleResourcesDownloadBar(this,${item.id})"/>
            <label for="${item.id}">
                ${item.title}
                <span>&nbsp;(${item.extension})</span>
            </label>
        </div>
        <div class="resources__actions__grid__item__link">
            <p><a href="${item.link}" target="_blank" class="arrow-link-alt-inverse" ${(item.extension === 'DWG' || item.extension === 'DXF') ? `disabled` : ``}>${(item.extension === 'DWG' || item.extension === 'DXF') ? `No Preview` : `Preview`}</a></p>
        </div>
    </div>`;
}


/**
 * 
 * Resources item card template
 * 
 * @param {object} item 
 * @param {array} selected_images 
 * @returns {string} html
 */
export const imagesItem = (item, selected_items) => {
    return /*html */`
    <div class="image-library__actions__grid__item" data-id="${item.id}" onclick="event.preventDefault();this.querySelector('input').checked = !this.querySelector('input').checked;this.querySelector('input').dispatchEvent(new Event('change'))">
        <div class="image-library__actions__grid__item__image">
            <img src="${item.link || '/themes/mercury/dist/images/standard/placeholder.png'}" width="100" height="100" loading="lazy" alt="${item.product_title}">
        </div>
        <div class="image-library__actions__grid__item__checkbox">
            <span>${item.product_code}</span>
            <input id="${item.id}" type="checkbox" ${(selected_items && selected_items.includes(item.id)) ? `checked="checked"` : ``} value="${item.id}" class="image-library__actions__grid__item__checkbox__input" onchange="toggleImagesDownloadBar(this,${item.id})"/>
            <label for="${item.id}"></label>
        </div>
    </div>`;
}



/**
 * 
 * No resutls message for the resources page
 * 
 * @returns {string} html
 */
export const resourcesNoResults = () => {
    return /*html */`
    <div class="resources__actions__grid__empty">
        <h4>No results found</h4>
    </div>`;
}


/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const resourcesFilterSectionItem = (title, filter) => {
    return /*html */`
    <div class="resources__filters__section__options__item">
        <input type="checkbox" onchange="updateFilters();" data-search="${title}-${filter}" id="${title}-${filter}" name="${title}" value="${filter}">
        <label for="${title}-${filter}">${filter}</label>
    </div>`
}


/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const imagesFilterSectionItem = (title, filter) => {
    return /*html */`
    <div class="image-library__filters__section__options__item">
        <input type="checkbox" onchange="updateFilters();" data-search="${title}-${filter}" id="${title}-${filter}" name="${title}" value="${filter}">
        <label for="${title}-${filter}">${filter}</label>
    </div>`
}

/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns  
 */
export const imagesFilterSectionExpandableItem = (title, filters) => {
    let html = ``;
    Object.keys(filters).forEach(filter => {
        html += /*html */`
        <div class="image-library__filters__section__options__expandable" data-title="${filter}">
            <div class="image-library__filters__section__options__expandable__header" onclick="event.preventDefault();this.parentNode.classList.toggle('active')">
                <p>${filter}</p>
            </div>
            <div class="image-library__filters__section__options__expandable__content">
                ${dedupe(filters[filter]).map(subfilter => imagesFilterSectionSubItem(title, filter, subfilter)).join('')}
            </div>
        </div>`
    });

    return html;
}



/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const faqFilterSectionItem = (title, filter) => {
    return /*html */`
    <div class="faq__filters__section__options__item">
        <input type="checkbox" onchange="uncheckOtherFilters(this);updateFilters();" data-search="${title}-${filter}" id="${title}-${filter}" name="${title}" value="${filter}">
        <label for="${title}-${filter}">${filter}</label>
    </div>`
}


/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const resourcesFilterSectionSubItem = (title, filter, subfilter) => {

    // Set a default sort order
    let order = 999999;

    // If we are looking at the range filters then we should have them im alphabetical order
    if (title === 'Range') order = subfilter.charAt(0).toLowerCase().charCodeAt(0) - 96;

    return /*html */`
    <div class="resources__filters__section__options__expandable__content__item" style="order:${order}">
        <input type="checkbox" onchange="updateFilters();" data-search="${title}-${filter}-${subfilter}" id="${title}-${filter}-${subfilter}" name="${title}" data-filter="${filter}" value="${subfilter}">
        <label for="${title}-${filter}-${subfilter}">${subfilter}</label>
    </div>`
}


/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const imagesFilterSectionSubItem = (title, filter, subfilter) => {
    return /*html */`
    <div class="image-library__filters__section__options__expandable__content__item">
        <input type="checkbox" onchange="updateFilters();" data-search="${title}-${filter}-${subfilter}" id="${title}-${filter}-${subfilter}" name="${title}" data-filter="${filter}" value="${subfilter}">
        <label for="${title}-${filter}-${subfilter}">${subfilter}</label>
    </div>`
}

/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const resourcesFilterSectionExpandableItem = (title, filters) => {
    let html = ``;
    Object.keys(filters).forEach(filter => {
        html += /*html */`
        <div class="resources__filters__section__options__expandable" data-title="${filter}">
            <div class="resources__filters__section__options__expandable__header" onclick="event.preventDefault();this.parentNode.classList.toggle('active')">
                <p>${filter}</p>
            </div>
            <div class="resources__filters__section__options__expandable__content">
                ${dedupe(filters[filter]).map(subfilter => resourcesFilterSectionSubItem(title, filter, subfilter)).join('')}
            </div>
        </div>`
    });

    return html;
}

/**
 * 
 * Remove duplicates from an Array
 * 
 * @param {array} arr 
 * @returns {array}
 */
const dedupe = (arr) => Array.from(new Set(arr));


/**
 * 
 * Sort an array in ascending order
 * 
 * @param {array} arr 
 * @returns 
 */
const sort = (arr) => arr.sort((a, b) => a - b);


/**
 * 
 * Sort an array in alphabetically
 * 
 * @param {array} arr 
 * @returns 
 */
const sortAlphabetically = (arr) => arr.sort((a, b) => a.localeCompare(b));


/**
 * 
 * Sort and array by specific key
 * We are only sortting these two field types at the moment
 * 
 * @param {array} arr 
 * @returns {array}
 */
const selectiveSort = (title, arr) => {
    if (title === 'Number Of Bowls') {
        return sort(arr);
    } else if (title === 'Range') {
        return sortAlphabetically(arr);
    } else {
        return arr;
    }
};



/**
 * 
 * Entire filtering section for the resources page
 * 
 * @param {string} title 
 * @param {string} filters 
 * @returns {string} html
 */
export const imagesFilterSection = (title, filters) => {
    return /*html */`
    <div class="image-library__filters__section" data-type="checkbox">
        <div class="image-library__filters__section__heading">
            <h6>${title}</h6>
            <a href="#" class="[ js-clear-section-filters ] colour--primary" onclick="event.preventDefault();clearSectionFilters(event.target.closest('.image-library__filters__section'))">clear</a>
        </div>
        <div class="image-library__filters__section__options">
            ${(filters.length) ? dedupe(filters).map(filter => imagesFilterSectionItem(title, filter)).join('') : imagesFilterSectionExpandableItem(title, filters)}
        </div>
        <hr>
    </div>`;
}


/**
 * 
 * Entire filtering section for the faq page
 * 
 * @param {string} title 
 * @param {string} filters 
 * @returns {string} html
 */
export const faqsFilterSection = (title, filters) => {
    return /*html */`
    <div class="faq__filters__section" data-type="checkbox">
        <div class="faq__filters__section__options">
            ${dedupe(filters).map(filter => faqFilterSectionItem(title, filter)).join('')}
        </div>
        <hr>
    </div>`;
}


/**
 * 
 * Entire filtering section for the resources page
 * 
 * @param {string} title 
 * @param {string} filters 
 * @returns {string} html
 */
export const resourcesFilterSection = (title, filters) => {
    return /*html */`
    <div class="resources__filters__section" data-type="checkbox">
        <div class="resources__filters__section__heading">
            <h6>${title}</h6>
            <a href="#" class="[ js-clear-section-filters ] colour--primary" onclick="event.preventDefault();clearSectionFilters(event.target.closest('.resources__filters__section'))">clear</a>
        </div>
        <div class="resources__filters__section__options">
            ${(filters.length) ? dedupe(filters).map(filter => resourcesFilterSectionItem(title, filter)).join('') : resourcesFilterSectionExpandableItem(title, filters)}
        </div>
        <hr>
    </div>`;
}


/**
 * 
 * Single category item for the resources page category filter
 * 
 * @param {string} category 
 * @returns 
 */
export const resourcesFilterCategory = (category) => {
    return /*html */`
    <a href="#" class="resources__categories__item" data-category="${category}" onclick="event.preventDefault();changeCategories('${category}')">${category}</a>`;
}


/**
 * 
 * Pagination page
 * 
 * @param {number} page 
 * @param {number} currentPage 
 * @returns {string} html
 */
export const paginationItem = (page, currentPage, pages) => {
    return /*html */`
    <button class="resources__pagination__pages__item ${(page === currentPage) ? 'active' : ''} ${(page >= pages) ? 'hidden' : ''}" onclick="paginate(${page})">${page + 1}</button>`
}


/**
 * 
 * pagination holder template, only renders if/when needed
 * 
 * @param {string} pages 
 * @param {string} currentPage 
 * @returns {string} html
 */
export const pagination = (pages, currentPage) => {


    return /*html */`
    <div class="resources__pagination"  style="${(pages === 1) ? `display:none;` : `display:flex;`}">
        <button class="resources__pagination__first" onclick="paginate('previous')">
            <img src="themes/mercury/dist/images/svg/medium-arrrow-left-black.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-left-black">
        </button>
        ${[...Array((pages > 5) ? 5 : pages).keys()].map((item, index) => paginationItem((currentPage > 3 && pages > 5) ? index - 2 + currentPage : index, currentPage, pages)).join('')}
        <button class="resources__pagination__last" onclick="paginate('next')">
            <img src="themes/mercury/dist/images/svg/medium-arrrow-right-black.svg" width="26" height="26" loading="lazy" alt="medium-arrrow-left-black">
        </button>
    </div>`
}


/**
 * 
 * No results message for the products page
 * 
 * @returns {string} html
 */
export const productsNoResults = () => {
    return /*html */`
    <div class="products__actions__grid__empty">
        <h4>No results found</h4>
    </div>`;
}

/**
 * 
 * No results message for the products page
 * 
 * @returns {string} html
 */
export const imagesNoResults = () => {
    return /*html */`
    <div class="image-library__actions__grid__empty">
        <h4>No results found</h4>
    </div>`;
}


/**
 * 
 * Category filter for the products page
 * 
 * @param {string} category 
 * @returns {string} html
 */
export const productsFilterCategory = (category) => {
    return /*html */`
    <a href="#" class="products__categories__item" data-category="${category}" onclick="event.preventDefault();changeCategories('${category}')">${category}</a>`;
}


/**
 * 
 * Category filter for the products page
 * 
 * @param {string} category 
 * @returns {string} html
 */
export const imagesFilterCategory = (category, index) => {

    return /*html */`
    <a href="#" class="image-library__categories__item ${(index === 0) ? `active` : ``}" data-category="${category}" onclick="event.preventDefault();changeCategories('${category}')">${category}</a>`;
}


/**
 * 
 * Update a title to be more human readable
 * 
 * @param {string} title 
 * @returns 
 */
const prettyFilter = (title, parent_title) => {

    switch (title) {
        case '1': title = (parent_title === 'Overflow') ? 'Yes' : title; break;
        case '0': title = (parent_title === 'Overflow') ? 'No' : title; break;
        default: break;
    }
    return title;
};


/**
 * 
 * Product filter checkbox item for the products page
 * 
 * @param {string} title 
 * @param {object} filter 
 * @returns {string} html
 */
export const productsFilterSectionItem = (title, filter) => {

    // Set our nominal flex order
    let flex_order = 999;

    // See if there is an overide present for the current category
    let sort_overide = window.filter_items_sort.find(item => item.group === title);

    // If there is an overide then we need to update the flex order for this item
    if (sort_overide) {
        sort_overide.options.forEach((option) => {
            if (filter === option.option) flex_order = option.sort_order + 1
        });
    }

    return /*html */`
        <div class="products__filters__section__options__item" style="order: ${flex_order}" data-filter="${filter}">
            <input type="checkbox" onchange="updateFilters(true);" data-search="${title}-${filter}" id="${title}-${filter}" name="${title}" value="${filter}">
            <label for="${title}-${filter}">${prettyFilter(filter, title)}</label>
        </div>`
}


/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const productsFilterSectionExpandableItem = (title, filters) => {
    let html = ``;
    Object.keys(filters).forEach(filter => {
        html += /*html */`
        <div class="products__filters__section__options__expandable" data-title="${filter}">
            <div class="products__filters__section__options__expandable__header" onclick="event.preventDefault();this.parentNode.classList.toggle('active')">
                <p>${filter}</p>
            </div>
            <div class="products__filters__section__options__expandable__content">
                ${dedupe(filters[filter]).map(subfilter => productsFilterSectionSubItem(title, filter, subfilter)).join('')}
            </div>
        </div>`
    });

    return html;
}



/**
 * 
 * Check box filtering item for the resources page
 * 
 * @param {string} title 
 * @param {string} filter 
 * @returns 
 */
export const productsFilterSectionSubItem = (title, filter, subfilter) => {
    return /*html */`
    <div class="products__filters__section__options__expandable__content__item">
        <input type="checkbox" onchange="updateFilters(true);" data-search="${title}-${filter}-${subfilter}" id="${title}-${filter}-${subfilter}" name="${title}" data-filter="${filter}" value="${subfilter}">
        <label for="${title}-${filter}-${subfilter}">${subfilter}</label>
    </div>`
}


/**
 * 
 * Remove the pluralised 'S' from the product titles
 * 
 * @param {string} title 
 * @returns {string} html
 */
const prettyTitle = (title) => {
    switch (true) {
        case title === 'Colour': return 'Finish';
        case title === 'Ranges': return 'Range';
        case title === 'Mounting Types': return 'Mounting Type';
        case title === 'Materials': return 'Material';
        default: return title;
    }
}


export const productFiltersSlider = (measurements) => {
    return /*html */`<div id="width-slider" data-min="${Math.min(...measurements)}" data-max="${Math.max(...measurements)}"></div>`;
};

export const getOrder = (title, subcategory) => {
    let order = 999999;

    Object.entries(filters_sort).forEach(([key, value]) => {
        if (title === key) order = value + 1;
    });

    return order;
};



/**
 * 
 * @param {*} title 
 * @param {*} filters 
 * @returns 
 */
export const productsFilterSection = (title, filters) => {

    let order = getOrder(title, window.subcategory);

    let should_be_hidden = (prettyTitle(title) === 'Overflow' && dedupe(filters).length === 1 && dedupe(filters)[0] === '0') ? true : false;

    // We need to update the order for this section
    return /*html */`
    <div class="products__filters__section" data-type="checkbox" style="order:${order};${(should_be_hidden) ? `display:none;` : ``}" data-section="${title}">
        <div class="products__filters__section__heading">
            <h6>${prettyTitle(title)}</h6>
            <a href="#" class="[ js-clear-section-filters ] colour--primary" onclick="event.preventDefault();clearSectionFilters(event.target.closest('.products__filters__section'))">clear</a>
        </div>
        <div class="products__filters__section__options">
        ${(title === 'Width' || title === 'Sink Width' || title === 'Basin Width' || title === 'Bath Size') ?
            productFiltersSlider(dedupe(filters))
            :
            (filters.length) ? selectiveSort(title, dedupe(filters)).map(filter => productsFilterSectionItem(title, filter)).join('') : resourcesFilterSectionExpandableItem(title, filters)
        }
        </div>
        <hr>
    </div>`;
}


/**
 * 
 * Individual swatch item for a product card
 * 
 * @param {object} item 
 * @param {number} index 
 * @param {number} parent_id 
 * @returns {string} html
 */
export const productsItemSwatch = (item, index, parent_id, bowlside_variations) => {
    return /*html */`
    <button class="products__actions__grid__item__swatches__item  ${(bowlside_variations.length > 1) ? `isBowl` : `isColour`} ${(index === 0) ? `active` : ``}" onclick="event.preventDefault();changeSwatchGrid(event.target.closest('.products__actions__grid__item'), ${item.id},'${item.link}?variation=${item.id}', '${item.code}')" data-parent-id="${parent_id}" data-id="${item.id}" data-colour="${item.colour_hex}" style="order:${(item.sort) ? item.sort : 999}">
        ${(item.bowl_side === 'Left' && bowlside_variations.length > 1) ? `<svg width="33" height="22" viewBox="0 0 33 22" xmlns="http://www.w3.org/2000/svg"><path d="M30.85.5c.91 0 1.65.75 1.65 1.67v17.66c0 .92-.74 1.67-1.65 1.67H2.15c-.91 0-1.65-.75-1.65-1.67V2.17C.5 1.25 1.24.5 2.15.5Zm0 1H2.15c-.36 0-.65.3-.65.67v17.66c0 .37.3.67.65.67h28.7c.36 0 .65-.3.65-.67V2.17c0-.37-.3-.67-.65-.67Zm-14.4 1.6a3.5 3.5 0 0 1 3.49 3.51v8.78a3.5 3.5 0 0 1-3.49 3.52H7.16a3.5 3.5 0 0 1-3.48-3.52V6.6A3.5 3.5 0 0 1 7.16 3.1Zm0 1H7.16A2.5 2.5 0 0 0 4.68 6.6v8.78a2.5 2.5 0 0 0 2.48 2.52h9.29a2.5 2.5 0 0 0 2.49-2.52V6.6a2.5 2.5 0 0 0-2.49-2.52Zm-4.64 1.3a2 2 0 0 1 1.98 2.01 2 2 0 0 1-1.98 2 2 2 0 0 1-2-2 2 2 0 0 1 2-2Zm0 1a1 1 0 0 0-1 1.01 1 1 0 0 0 1 1 1 1 0 0 0 .98-1 1 1 0 0 0-.98-1Z" fill="#B8B8B8" fill-rule="nonzero"/></svg>` : ``}
        ${(item.bowl_side === 'Right' && bowlside_variations.length > 1) ? `<svg width="33" height="22" viewBox="0 0 33 22" xmlns="http://www.w3.org/2000/svg"><path d="M30.85.5c.91 0 1.65.75 1.65 1.67v17.66c0 .92-.74 1.67-1.65 1.67H2.15c-.91 0-1.65-.75-1.65-1.67V2.17C.5 1.25 1.24.5 2.15.5Zm0 1H2.15c-.36 0-.65.3-.65.67v17.66c0 .37.3.67.65.67h28.7c.36 0 .65-.3.65-.67V2.17c0-.37-.3-.67-.65-.67ZM25.2 3.1A3.5 3.5 0 0 1 28.7 6.6v8.78a3.5 3.5 0 0 1-3.49 3.52h-9.29a3.5 3.5 0 0 1-3.48-3.52V6.6a3.5 3.5 0 0 1 3.48-3.52Zm0 1h-9.29a2.5 2.5 0 0 0-2.48 2.51v8.78a2.5 2.5 0 0 0 2.48 2.52h9.29a2.5 2.5 0 0 0 2.49-2.52V6.6A2.5 2.5 0 0 0 25.2 4.1Zm-4.64 1.3a2 2 0 0 1 1.98 2.01 2 2 0 0 1-1.98 2 2 2 0 0 1-1.99-2 2 2 0 0 1 1.99-2Zm0 1a1 1 0 0 0-.99 1.01 1 1 0 0 0 .99 1 1 1 0 0 0 .98-1 1 1 0 0 0-.98-1Z" fill="#B8B8B8" fill-rule="nonzero"/></svg>` : ``}
        ${(bowlside_variations.length <= 1) ? `<span style="background-color:${item.colour_hex};${(item.colour_hex === '#ffffff') ? `border: 1px solid #ccc` : ``}"></span>` : ``}
    </button>`;
}


/**
 * 
 * Product made in tag that sits top left of product card
 * 
 * @param {object} item 
 * @returns {string} html
 */
export const newProductBadge = (variation, index, id) => {
    return /*html */`
    <span class="products__actions__grid__item__new-product ${(index === 0) ? `active` : ``}" data-id="${variation.id}">
    ${(variation.is_new) ? `<img src="themes/mercury/dist/images/svg/new-product-small.svg" width="25" height="25" loading="lazy" alt="New product badge">` : ``}
    </span>`;
}

/**
 * 
 * Product made in tag that sits top left of product card
 * 
 * @param {object} item 
 * @returns {string} html
 */
export const comingSoonProductBadge = (variation, index, id) => {
    return /*html */`
    <span class="products__actions__grid__item__coming-soon ${(index === 0) ? `active` : ``}" data-id="${variation.id}">
    ${(variation.is_coming_soon) ? `<img src="themes/mercury/dist/images/svg/coming-soon-product.svg" width="106" height="28" loading="lazy" alt="Coming soon badge">` : ``}
    </span>`;
}



/**
 * 
 * Individual image item for a product card
 * 
 * @param {object} item 
 * @returns {string} html
 */
export const productsItemImage = (item, index) => {
    return /*html */`<img class="products__actions__grid__item__images__item ${(index === 0) ? `active` : ``}" src="${item.image}" width="280" height="280" loading="lazy" alt="${item.colour}" data-id="${item.id}">`;
}


/**
 * 
 * Individual price for a product card
 * 
 * @param {object} item 
 * @returns {string} html
 */
export const productsItemPrice = (item, index) => {
    return /*html */`<span class="products__actions__grid__item__details__price__item ${(index === 0) ? `active` : ``}" data-id="${item.id}">${(item.purchaseable) ? `$${item.price}` : ``}</span>`;
}


/**
 * 
 * Product template for the product holder page
 * 
 * @param {object} item 
 * @param {array} wishlist 
 * @returns 
 */
export const productsItem = (item, wishlist_items = []) => {

    // Test to see if the item is in the users wishlist
    let hearted = (wishlist_items.includes(item.code)) ? 'hearted' : '';

    // Get the images for the product
    let images = (item.variations.length) ? item.variations.map((variation, index) => productsItemImage(variation, index)).join('') : productsItemImage(item, 0);

    // Get the coming soons
    let new_badges = (item.variations.length) ? item.variations.map((variation, index) => newProductBadge(variation, index, item.id)).join('') : newProductBadge(item, 0, item.id);

    // Get the coming soons
    let coming_soon_badges = (item.variations.length) ? item.variations.map((variation, index) => comingSoonProductBadge(variation, index, item.id)).join('') : comingSoonProductBadge(item, 0, item.id);

    // Get the colour swatches for the product
    let swatches = (item.variations) ? item.variations.map((variation, index) => productsItemSwatch(variation, index, item.id, item.bowlside_variations)).join('') : productsItemSwatch(variation, 0, item.id);

    // Get the prices for the product
    let prices = (item.variations.length) ? item.variations.map((variation, index) => productsItemPrice(variation, index)).join('') : productsItemPrice(item, 0);

    // Show or hide the pricing
    let show_price = false;

    // If every bowlside variation is purchaseable then show the price
    if (item.bowlside_variations.every(bowlside_variation => bowlside_variation.purchaseable)) {
        show_price = true;
    }

    // If every colour variation is purchaseable then show the price
    if (item.colour_variations.every(colour_variation => colour_variation.purchaseable)) {
        show_price = true;
    }

    // If there are no variations and the item is not purchaseable then hide the price
    if (item.bowlside_variations.length === 0 && item.colour_variations.length === 0 && item.purchaseable === false) {
        show_price = false;
    }


    return /*html */`
    <div class="products__actions__grid__item" data-id="${item.id}">
    
    <span class="heart [ js-toggle-item-from-wishlist ] ${hearted} " data-id="${item.code}">
        <img class="heart__image-1" src="themes/mercury/dist/images/svg/brown-heart.svg" width="25" height="21" loading="lazy" alt="brown-heart">
        <img class="heart__image-2" src="themes/mercury/dist/images/svg/brown-heart-full.svg" width="25" height="21" loading="lazy" alt="brown-heart">
        <svg width="25" height="21" viewBox="0 0 25 21" xmlns="http://www.w3.org/2000/svg"><path d="M22.554 2.813c-2.025-1.81-5.196-1.75-7.144.18l-3.015 3.02-3.048-3.017C7.333 1 4.02 1 2.007 2.996a5.115 5.115 0 0 0 0 7.25L12.393 20.5l10.355-10.252a5.116 5.116 0 0 0 .183-7.061l-.183-.19-.193-.181v-.002Z" stroke="#818185" fill="none" fill-rule="evenodd"/></svg>
    </span>

    <a href="${item.link}" class="products__actions__grid__item__images">
        ${images}
    </a>

    <div class="products__actions__grid__item__new-badges">
        ${new_badges}
    </div>

    <div class="products__actions__grid__item__comings-soon-badges">
        ${coming_soon_badges}
    </div>
    
    <div class="products__actions__grid__item__swatches">
        ${swatches}
    </div>
    
    <a href="${item.link}" class="products__actions__grid__item__details">
        <p class="products__actions__grid__item__details__title"><b>${item.title}</b></p>
        <p class="products__actions__grid__item__details__sku">${(item.variations.length) ? item.variations[0].code : item.code}</p> 
        <p class="products__actions__grid__item__details__price"><b>${prices}</b></p>
    </a>
        
</div>`;
    {/* <p class="products__actions__grid__item__details__price"><b>${(show_price && item.price !== 0) ? `${numeral(parseFloat(item.price).toFixed(2)).format('$0,0.00')}` : `&nbsp;`}</b></p> */ }

}

export const faqItem = (item) => {
    return /*html */`
    <section class="accordion">
        <div class="accordion__wrap">
            <div class="accordion__wrap__item" id="accordion_${item.id}_${item.id}">
                <div href="#" class="accordion__wrap__item__heading" onclick="toggleActive('accordion_${item.id}_${item.id}')">
                    <h5 class="accordion__wrap__item__heading__title">${item.title}</h5>
                </div>
                <div class="accordion__wrap__item__content">
                    <div class="accordion__wrap__item__content__inner">
                        ${item.answer}
                    </div>
                </div>
            </div>
        </div>
    </section>
    `;

}


const quantity = (item) => {
    return /*html*/`
    <div class="quantity" data-id="${item.product_id}">
        <div class="quantity__subtract [ js-decrease-quantity-checkout ]">
            <img src="/themes/mercury/dist/images/svg/subtract-light.svg" width="40" height="40" loading="lazy" alt="subtract" data-api-url="${item.remove_one}">
        </div>
        <div class="quantity__input [ js-quantity-checkout ]">
            <input type="number" class="quantity__input__field" value="${item.quantity}" min="1" max="100">
        </div>
        <div class="quantity__add [ js-increase-quantity-checkout ]">
            <img src="/themes/mercury/dist/images/svg/add-light.svg" width="40" height="40" loading="lazy" alt="add" data-api-url="${item.remove_one}">
        </div>
    </div>`;
};


/**
 * 
 * Return the template for a checkout item
 * @param {object} item
 * 
 */
export const checkoutItem = (item) => {
    return /*html*/`
    <div class="checkout-step__wrap__sidebar__list__body__item" data-id="${item.product_id}">
        <a href="${item.url}" class="checkout-step__wrap__sidebar__list__body__item__image">
            ${(item.thumbnail) ? `<img src="${item.thumbnail}" width="200" height="200" loading="lazy" alt="placeholder-image">` : `<img src="https://via.placeholder.com/200" width="200" height="200" loading="lazy" alt="placeholder-image">`}
        </a>
        <div class="checkout-step__wrap__sidebar__list__body__item__details">
            <p><a href="${item.url}" class="colour--secondary"><span>${item.sku}</span><br>${item.title}</a></p>
            <p class="checkout-step__wrap__sidebar__list__body__item__details__price colour--primary smaller">${numeral(parseFloat(item.unit_price).toFixed(2)).format('$0,0.00')} <span>${quantity(item)}</span></p>
        </div>
        <button class="checkout-step__wrap__sidebar__list__body__item__remove [ js-remove-item-from-sidecart ]" data-remove-url="${item.item_actions.remove_all}" data-quantity="${item.quantity}" data-id="${item.product_id}">
            <img src="/themes/mercury/dist/images/svg/close-tiny.svg" width="14" height="14" loading="lazy" alt="close-tiny">
        </button>
    </div>`;
}

export const modifierItem = (modifier) => {
    if (modifier.total === 0 && modifier.class === "FlatProductFreeShipping") {
        return /*html*/`
        <p class="checkout-step__wrap__sidebar__list__body__modifier">
            ${modifier.title} <span>Free</span>
        </p>`;
    } else if (modifier.total > 0) {
        return /*html*/`
        <p class="checkout-step__wrap__sidebar__list__body__modifier">
            ${modifier.title} <span>${(modifier.type === 'Deductable') ? `-` : ``}${numeral(parseFloat(modifier.total).toFixed(2)).format('$0,0.00')}</span>
        </p>`;
    }
    return '';
}

export const checkoutTotals = (cart) => {
    return /*html*/`
    <p class="checkout-step__wrap__sidebar__list__body__subtotal">
        Subtotal <span>${numeral(parseFloat(cart.subtotal).toFixed(2)).format('$0,0.00')}</span>
    </p>

    ${cart.modifiers.map((modifier, index) => modifierItem(modifier)).join('')}

    <p class="checkout-step__wrap__sidebar__list__body__total">
        Total <span>${numeral(parseFloat(cart.total).toFixed(2)).format('$0,0.00')}</span>
    </p>`;
};


/**
 * 
 * Return the template for a sidecart item
 * @param {object} item
 * 
 */
export const checkoutEmpty = () => {
    return /*html*/`
    <div class="checkout-step__wrap__sidebar__list__body__empty">
        <p class="text-center"><img src="/themes/mercury/dist/images/svg/placeholder.svg" width="200" height="200" loading="lazy" alt="empty-cart"></p>
        <p class="text-center">You have not selected any products.<br><br></p>
        <p class="text-center"><a href="/" class="button">Continue browsing<a></p>
    </div>`
}

